import { render, staticRenderFns } from "./ShowCheckboxList.vue?vue&type=template&id=a3845502"
import script from "./ShowCheckboxList.vue?vue&type=script&lang=js"
export * from "./ShowCheckboxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports